module.exports = __webpack_public_path__ + "static/media/setting.d3661992.svg";